import { render, staticRenderFns } from "./Rounded.vue?vue&type=template&id=aa8a58f0&"
import script from "./Rounded.vue?vue&type=script&lang=js&"
export * from "./Rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports